/**
 * Dải nút chuyển màn của máy trạm đóng gói (FD-393): người ở kho muốn xem
 * ngay định vị xe hay bảng công việc thì bấm, không phải đợi tới lượt xoay.
 */

import type { StationScreen } from '@/hooks/use-station-screen-rotation'

import { m } from '@/lib/paraglide/messages'

const LABELS: Record<StationScreen, () => string> = {
    orders: m.station_screen_orders,
    fleet: m.station_screen_fleet,
    work: m.station_screen_work,
}

export function StationScreenSwitcher({
    screen,
    screens,
    onSelect,
}: {
    screen: StationScreen
    /** Màn có nút, theo thứ tự vòng xoay. */
    screens: StationScreen[]
    onSelect: (target: StationScreen) => void
}) {
    return (
        <div
            role="group"
            aria-label={m.station_screen_switch_label()}
            className="station-chrome flex flex-wrap items-center gap-2 border-b border-[var(--line)] px-5 py-2"
        >
            {screens.map((target) => {
                const active = target === screen
                return (
                    <button
                        key={target}
                        type="button"
                        aria-pressed={active}
                        onClick={() => onSelect(target)}
                        className={`station-btn min-h-11 ${active ? 'on' : ''}`}
                    >
                        {LABELS[target]()}
                    </button>
                )
            })}
        </div>
    )
}
